import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WebSocketSubject } from 'rxjs/webSocket';
import { environment } from "../../environments/environment";
import { HttpClient } from '@angular/common/http';



@Injectable({
    providedIn: 'root'
})
export class SocketService {
    private socket:any;
    private socket_url: string = environment.HOST.SOCKET_LINK;
    public messageReceived = new BehaviorSubject<any>(null)
    public connectionId = null; 

    host_api_url = environment.HOST.HOST_API_URL;

    constructor(private http: HttpClient){
    }

    /* Socket connection */
    public connect(school_id: string , user_id: string){
        this.socket =  new WebSocketSubject({
            url: this.socket_url,
            closeObserver: {
                next: () => {
                    this.connect(school_id, user_id)
                }
            }
        });
        this.socket.next({
            action: 'userconnect',
            data: {
                school_id,
                user_id
            }
        });
        this.socket.subscribe(
            (message: any) => { 
                if (message.connectionId) {
                    this.connectionId = message.connectionId;
                }
                this.messageReceived.next(message);
            },
            (errored: any) => {},
        );

    }
    
    // sendMessageWS(payload:any): Observable<any> {
    //       return this.http.post(this.api_url + '/interviewLobby/sendMessageWS/', payload, this.options())
    //   }


    
}
